import React from 'react';

export interface HtmlStringProps {
    htmlString: string;
    skipAlignmentClasses?: boolean;
}

const HtmlStringComponent = ({ htmlString, skipAlignmentClasses, ...rest }: HtmlStringProps & React.HTMLAttributes<Element> ): React.ReactElement | null => {
    let classes: string = rest?.className ? rest.className : '';
    classes = `${classes} space-y-4 html-string-component`;
    if (!skipAlignmentClasses) {
        classes = `${classes} text-center lg:text-left`;
    }

    if (rest) {
        rest.className = classes;
    }

    // if alignment classes were used, change them to only apply on large screens so content
    // can be centered on mobile sizes
    let modifiedHtml: string = htmlString;
    if (!skipAlignmentClasses) {
        modifiedHtml = modifiedHtml.replace(/text-right/g, 'lg:text-right');
        modifiedHtml = modifiedHtml.replace(/text-left/g, 'lg:text-left');
    }

    // React intentionally named this for the programmer to be mindful of what they're doing. We are
    // setting the HTML from a string generated in the CMS https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
    return <div dangerouslySetInnerHTML={ { __html: modifiedHtml } } {...rest}></div>;
};

export default HtmlStringComponent;
